const resources = {
    showPasswordLinkAriaLabel: 'Montrer le mot de passe',
    hidePasswordLinkAriaLabel: 'Cacher le mot de passe'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
